module.exports = __webpack_public_path__ + "static/media/toubiaoxize.c8df6a5d.png";